"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetsClient = void 0;
var base_client_1 = require("./base-client");
/**
 * Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
API and offers examples of usage.

The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
 * @class AssetsClient
 * @param {(string)} [url] - The URL of the API endpoint.
 */
var AssetsClient = /** @class */ (function (_super) {
    __extends(AssetsClient, _super);
    function AssetsClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Retrieve a list of assets for a specified owner.
     * @method
     * @name AssetsClient#listAssets
     * @param {string} owner - The owner id you are requesting data for
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    AssetsClient.prototype.listAssets = function (owner, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/assets';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new asset entity
    * @method
    * @name AssetsClient#createAsset
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    AssetsClient.prototype.createAsset = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assets';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    body = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns asset details for the specified id
     * @method
     * @name AssetsClient#getAsset
     * @param {string} id - The UUID of the asset
     */
    AssetsClient.prototype.getAsset = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/assets/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing asset
    * @method
    * @name AssetsClient#updateAsset
         * @param {string} id - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    AssetsClient.prototype.updateAsset = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assets/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    body = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns the latest known telemetry record for an asset using a shared token
     * @method
     * @name AssetsClient#getSharedAssetLocation
     * @param {string} token - The shared token
     */
    AssetsClient.prototype.getSharedAssetLocation = function (token, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/assets/shared/location/{token}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (token === undefined || token === null) {
                            throw new Error('Missing required string parameter: token');
                        }
                        path = path.replace('{token}', token.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Update a shared asset location token
    * @method
    * @name AssetsClient#updateSharedAssetLocationToken
         * @param {string} token - The shared asset token to update
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    AssetsClient.prototype.updateSharedAssetLocationToken = function (token, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assets/shared/location/{token}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (token === undefined || token === null) {
                    throw new Error('Missing required string parameter: token');
                }
                path = path.replace('{token}', token.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    body = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Deletes a shared asset location token
     * @method
     * @name AssetsClient#deleteSharedAssetLocationToken
     * @param {string} token - The shared asset token to delete
     */
    AssetsClient.prototype.deleteSharedAssetLocationToken = function (token, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assets/shared/location/{token}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (token === undefined || token === null) {
                    throw new Error('Missing required string parameter: token');
                }
                path = path.replace('{token}', token.toString());
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('DELETE', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of shared asset tokens for an asset or client.
     * @method
     * @name AssetsClient#listSharedAssetLocationTokens
     * @param {string} owner - The owner id you are requesting data for
     * @param {string} asset - The asset id you are requesting data for
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    AssetsClient.prototype.listSharedAssetLocationTokens = function (owner, asset, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/assets/shared/location';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (asset !== undefined) {
                            queryParameters['asset'] = asset;
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new shared asset location token
    * @method
    * @name AssetsClient#createSharedAssetLocationToken
         * @param {string} id - The UUID of the asset
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    AssetsClient.prototype.createSharedAssetLocationToken = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assets/shared/location/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    body = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
    * Update asset privacy mode
    * @method
    * @name AssetsClient#setAssetPrivacy
         * @param {string} id - The UUID of the asset
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    AssetsClient.prototype.setAssetPrivacy = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assets/{id}/privacy';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    body = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Return the asset avatar in binary format
     * @method
     * @name AssetsClient#getAssetAvatar
     * @param {string} id - The UUID of the asset
     */
    AssetsClient.prototype.getAssetAvatar = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/assets/{id}/avatar';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
     * Updates the specified asset's avatar.
     * @method
     * @name AssetsClient#updateAssetAvatar
     * @param {string} id - The asset UUID you are requesting data for.
     */
    AssetsClient.prototype.updateAssetAvatar = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assets/{id}/avatar';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Permanently deletes a asset avatar.
     * @method
     * @name AssetsClient#deleteAssetAvatar
     * @param {string} id - The asset UUID.
     */
    AssetsClient.prototype.deleteAssetAvatar = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assets/{id}/avatar';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('DELETE', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns the latest known telemetry record for an asset
     * @method
     * @name AssetsClient#getAssetLocation
     * @param {string} id - The UUID of the asset
     */
    AssetsClient.prototype.getAssetLocation = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/assets/{id}/location';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Links an asset from one account to one in another account. All data from the source asset will be duplicated for the destination asset.
    Returns both the source and destination asset if successful.
    * @method
    * @name AssetsClient#linkAssets
         * @param {string} id - The source asset UUID you would like to link.
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    AssetsClient.prototype.linkAssets = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assets/{id}/link';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    body = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
    * Unlinks an asset linked to another.
    Returns both the source and destination asset if successful.
    * @method
    * @name AssetsClient#unlinkAssets
         * @param {string} id - The source asset UUID you would like to unlink from.
         * @param {string} asset - The destination asset UUID you would like to unlink from.
    */
    AssetsClient.prototype.unlinkAssets = function (id, asset, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assets/{id}/unlink/{asset}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (asset === undefined || asset === null) {
                    throw new Error('Missing required string parameter: asset');
                }
                path = path.replace('{asset}', asset.toString());
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
    * Moves an asset from one client to another by deleting the asset in the source client and recreating it in the destination client. Also moves any associated device and simcard if assigned.
    * @method
    * @name AssetsClient#moveAsset
         * @param {string} id - The asset UUID you would like to move.
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    AssetsClient.prototype.moveAsset = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, body, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assets/{id}/move';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    body = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, body, headers, queryParameters, form).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    return AssetsClient;
}(base_client_1.BaseClient));
exports.AssetsClient = AssetsClient;
